<template>
  <v-container
    class="pa-2"
    style="max-width: 1920px"
  >
    <preview
      id="preview-project"
      :controllers-project="[creationController]"
      :is-preview="true"
      :reset.sync="reset"
      :show="showPreview"
    />
    <v-row>
      <v-col>
        <v-row justify="start">
          <v-col>
            <v-toolbar ref="toolbar">
              <v-row>
                <standard-options
                  ref="standardOptions"
                  :project-name="computedProjectName"
                  :project-duration="projectDuration"
                  @loadFile="loadFile"
                  @saveFile="saveFile"
                />
              </v-row>
            </v-toolbar>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-overflow-btn
              v-model="pResolution"
              dense
              :items="cResolution"
              :label="$t('project.size-preset')"
              @change="resolutionChanged"
            />
          </v-col>
        </v-row>

        <v-row
          align="stretch"
          class="mt-0"
          style="padding-bottom: 300px"
        >
          <v-col
            ref="creationPageWorkspaceContainer"
            v-resize="onResize"
            class="creation-page-workspace-container"
          >
            <!-- <textarea placeholder="Votre texte..." v-model="textMsg" /> -->
            <text-editor-XS
              :value.sync="textMsg"
              class=""
            />
            <v-btn
              class="mt-3"
              width="100%"
              @click="saveFastProject"
            >
              {{ $t("dialog.save") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            ref="creationPageWorkspaceContainer"
            v-resize="onResize"
            class="creation-page-workspace-container"
          >
            <v-stage
              ref="creationPageWorkspace"
              class="creation-page-workspace"
              :config="configKonva"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Components
// import leftToolbar from './CreationPage/LeftToolbar';
// import rightPanel from './CreationPage/RightPanel';
// import geometryOptions from './CreationPage/EditTools/Options/GeometryOptions';
// import positionOptions from './CreationPage/EditTools/Options/PositionOptions';
import standardOptions from "./CreationPage/EditTools/Options/StandardOptions";
// import dialogMessage from "./Common/DialogMessage";

// Controllers
import { CreationController } from "./CreationPage/CreationController";
// import { ProjectSaver } from './CreationPage/SaveManager/ProjectSaver';
// import { ProjectLoader } from './CreationPage/SaveManager/ProjectLoader';
import { Project } from "./MainObjects/Project";
import textEditorXS from "./Common/TextEditorXS";

// Connectors
// import { ProjectConnector } from './Database/ProjectConnector';
// import { TemplateConnector } from './Database/TemplateConnector';

// function checkValueInt(value, defaultValue) {
//   const parsed = parseInt(value, 10);
//   if(isNaN(parsed)) {
//     return defaultValue;
//   }
//   return parsed;
// }

// function checkValueFloat(value) {
//   const parsed = parseFloat(value);
//   if(isNaN(parsed)) {
//     return 0.01;
//   }
//   return parsed;
// }

export default {
  components: {
    standardOptions,
    textEditorXS,
  },
  props: {
    projectName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      //contentOfTextOption: null,
      //currentObjectOption: {},
      //deleted: false,
      //leaveResponse: '0',
      //isInputFocused: false,
      //isStageMoving: false,
      //layers: [],
      //mouseDown: false,
      //templatePath: "share/template/private",
      baseConfigKonva: {
        x: 0,
        y: 0,
        width: 1920,
        height: 1080,
        scale: {
          x: this.scale,
          y: this.scale,
        },
      },
      creationController: new CreationController(),
      showPreview: false,
      project: new Project(),
      projectLoader: null,
      projectDuration: 10,
      reset: false,
      scale: 1,
      unsavedChange: false,
      saveInfo: "",
      thumbnail: "",
      textMsg: "",
      pResolution: 0,
      pRatio: 16 / 9,
      pWidth: "",
      pName: "",
      pHeight: "",
      resolutions: {
        landscape: [
          "4K (3840 x 2160)",
          "Full HD (1920 x 1080)",
          "LED p3.9 6m² (768 x 512)",
          "LED p3.9 3m² (512 x 384)",
          "LED p3.9 2.18m² (448 x 320)",
          "LED p3.9 1.5m² (384 x 256)",
          "LED p5.9 6m² (504 x 336)",
          "LED p5.9 3m² (336 x 252)",
          "LED p5.9 2.18m² (294 x 210)",
          "LED p5.9 1.5m² (252 x 168)",
        ],
        portrait: [
          "4K (2160 x 3840)",
          "Full HD (1080 x 1920)",
          "LED p3.9 6m² (512 x 768)",
          "LED p3.9 3m² (384 x 512)",
          "LED p3.9 2.18m² (320 x 448)",
          "LED p3.9 1.5m² (256 x 384)",
          "LED p5.9 6m² (336 x 504)",
          "LED p5.9 3m² (252 x 336)",
          "LED p5.9 2.18m² (210 x 294)",
          "LED p5.9 1.5m² (168 x 252)",
        ],
      },
    };
  },
  computed: {
    computedCurrentElement() {
      if (this.creationController.currentElement != null) {
        this.creationController.disableDraggable();
      }

      return this.creationController.currentElement;
    },
    stage() {
      return this.$refs.creationPageWorkspace.getStage();
    },
    configKonva() {
      return this.baseConfigKonva;
    },
    computedProjectName: {
      get() {
        return this.creationController.projectName;
      },
      // set(val) {
      //   this.creationController.projectName = val;
      // }
    },
    cWidth: {
      get() {
        return this.pWidth;
      },
      set(value) {
        this.pWidth = parseInt(value);
        this.$emit("sizeUpdated", { width: this.pWidth, height: this.pHeight });
      },
    },
    cHeight: {
      get() {
        return this.pHeight;
      },
      set(value) {
        this.pHeight = parseInt(value);
        this.$emit("sizeUpdated", { width: this.pWidth, height: this.pHeight });
      },
    },
    cOrientationName: {
      get() {
        if (this.cWidth >= this.cHeight) {
          return "landscape";
        } else {
          return "portrait";
        }
      },
    },
    cResolution: {
      get() {
        return this.resolutions[this.cOrientationName];
      },
    },
  },
  created() {
    document.title = this.$t("navbar.creation") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.creation"));
  },
  //This is where the creation controller is created. It loads or creates a new project according to how you came to this page.
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.$nextTick(function () {
        this.manageNewProject();
        //this.setupKeys();
        this.onResize();

        try {
          this.stage.draw();
        } catch (err) {
          console.error(err);
        }
      });
    }
  },
  methods: {
    loadFile() {},
    onResize() {},
    saveFile() {},
    resolutionChanged() {
      const completeResolution = this.pResolution.split("(")[1].replace(")", "");
      const dimensions = completeResolution.split(" x ");

      this.cWidth = dimensions[0];
      this.cHeight = dimensions[1];

      if (this.cHeight > 0) {
        this.pRatio = this.cWidth / this.cHeight;
      } else {
        this.pRatio = this.cWidth / 1;
      }
    },

    manageNewProject() {
      //if(this.$store.state.project.isNew) {
      this.creationController.createCompleteController(
        this.stage,
        this.$store.state.project.properties,
        this.$store.state.project.name
      );
      // }
      // else {
      //   this.loadFile(this.$store.state.project.openData);
      // }
    },

    saveFastProject() {
      this.$emit("textEditElement", {
        name: "text",
        content: this.textMsg,
        config: this.computedCurrentElement.konvaObjectOption,
      });
    },
  },
};
</script>

<style>
textarea {
  border: 1px solid rgb(82, 82, 82);
  border-radius: 4px;
  padding: 10px;
  width: 100%;
  height: 200px;
  color: white;
  font-size: 14px;
}
</style>
